export default "/images/38c17af9cc571cfab38ec46d5ea20cb6.avif";